import React, { FormEvent, useEffect, useState } from 'react';
import {
  Container,
  Logo,
  Box,
  Form,
  Input,
  Button,
  ButtonSecundario,
  ErrorMessage,
} from './LoginStyle';
import { useNavigate } from 'react-router-dom';
import {  Home } from '../../routes/RoutesNames';
import useAuth from '../../hooks/useAuth';
import { Loader } from '../../shared/components/Loader';

const Login = () => {
  const navigate = useNavigate();
  const [login, setLogin] = useState<string>('');
  const [senha, setSenha] = useState<string>(''); //ChangeEvent<HTMLInputElement
  const [liberado, setLiberado] = useState<boolean>();

  /* A mensagem pode vir de dois lugares: da tentativa de login que acabou de falhar, ou do
     interceptador do Api.ts, quando a sessao foi encerrada e a pessoa foi trazida para ca
     por um redirecionamento - caso em que esta tela nasce do zero e nao teria como saber
     o motivo. Por isso o localStorage: ele sobrevive a recarga da pagina.
     E lido UMA vez e apagado, senao a explicacao de hoje reapareceria amanha. */
  const [aviso, setAviso] = useState<string | null>(null);

  useEffect(() => {
    try {
      const guardado = localStorage.getItem('loginError');
      if (guardado) {
        setAviso(guardado);
        localStorage.removeItem('loginError');
      }
    } catch {
      // navegador sem armazenamento: segue sem a explicacao
    }
  }, []);
  const [loading, setLoadging] = useState<boolean>(false);
  const authContext = useAuth()


  /* [28/10] O "Encerrar a sessao anterior e entrar".
     Fechar a aba nao avisa o servidor, entao a sessao sobrevive e o proprio dono fica
     de fora ate ela morrer por inatividade - 5 minutos olhando para uma mensagem.
     O botao so aparece depois de um 409 (sessao ativa), nunca numa recusa de senha:
     numa credencial errada, oferecer "derrubar a sessao" contaria a quem tenta
     adivinhar que aquele usuario existe e esta logado agora.
     E ele reenvia o MESMO login e senha - a derrubada viaja junto da credencial, que e
     conferida antes de a sessao sequer ser consultada. */
  const entrarDerrubando = async () => {
    await validarLogin(undefined, true);
  };

  const validarLogin = async (e?: FormEvent<HTMLFormElement>, forcar = false) => {
    try {
      e?.preventDefault();

      setLoadging(true);
      setAviso(null);
      const response = await authContext.signIn(login, senha, forcar);

      if (response) {
        navigate(Home);
      } else {
        setLiberado(false);

        try {
          const motivo = localStorage.getItem('loginError');
          if (motivo) {
            setAviso(motivo);
            localStorage.removeItem('loginError');
          }
        } catch {
          // sem armazenamento: cai no texto reserva
        }
      }
    } finally {
      setLoadging(false);
    }
  };

  return (
    <React.Fragment>
      <Loader 
        loading={loading}
        >
        <Container>
          <Logo src='/images/promatec.png' alt='Promatec' />
          <Box>
            <Form onSubmit={validarLogin}>
              <Input
                type='text'
                onChange={(text) => {
                  setLogin(text.target.value);
                }}
                placeholder='Login'
              />
              <Input
                type='password'
                onChange={(text) => {
                  setSenha(text.target.value);
                }}
                placeholder='Senha'
              />
              {/* [22/10] Mostra a mensagem que veio do servidor, e nao um texto fixo.
                  Com a sessao unica, a recusa mais comum passa a ser "ja existe sessao
                  ativa em outro dispositivo, aberta as HH:mm" - dizer "senha invalida"
                  nesse caso manda a pessoa para o lado errado. O texto fixo fica como
                  reserva, para quando nao houver mensagem nenhuma. */}
              {(liberado == false || aviso) && (
                <ErrorMessage>
                  {aviso || 'Login e/ou senha inválidos.'}
                </ErrorMessage>
              )}
              {authContext.sessaoBloqueada && (
                <ButtonSecundario type='button' onClick={entrarDerrubando}>
                  Encerrar sessão e entrar
                </ButtonSecundario>
              )}
              <Button type='submit'>Login</Button>
            </Form>
          </Box>
        </Container>
      </Loader>

    </React.Fragment>
  );
};

export default Login;
